
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1.2em","height":"1.2em","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h32v32H0z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M28 6h-.586L30 3.414 28.586 2 2 28.586 3.414 30l4-4H28a2.003 2.003 0 002-2v-5a1 1 0 00-1-1 2 2 0 010-4 1 1 0 001-1V8a2 2 0 00-2-2m0 6.127a4 4 0 000 7.746V24h-7v-3h-2v3H9.414L19 14.414V19h2v-6.586L25.414 8H28zm-24 0V8h15V6H4a2 2 0 00-2 2v5a1 1 0 001 1 2 2 0 010 4 1 1 0 00-1 1v5h2v-4.127a4 4 0 000-7.746"}})])
          )
        }
      }
    